import { Permission } from "helpers";

export const OverviewListItem = ({ name, data }: { name: string; data: Permission[] | any[] }) => (
  <div>
    <span className="font-bold">{name}: </span>
    <span>{data.map(({ name }) => name).join(", ")}</span>
  </div>
);
